import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<UserPermissionResponse, {}>({
    query: () => ({
      url: `v4/pitch-owner/permissions`,
      method: 'POST',
    }),
  });

export interface UserPermission {
  id: number;
  name: string;
  description: string;
}

export interface UserPermissionResponse {
  data: {
    user_id: number;
    permissions: UserPermission[];
  };
}
